import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { useSelector } from "react-redux";

export function Brand() {
  const uiService = useHtmlClassService();
  const [fav, setFav] = useState(false);
  const handler = () => {
    setFav(!fav);
  };
  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo(),
    };
  }, [uiService]);
  let ApiUrl = `${process.env.REACT_APP_API_END_POINT}`;
  let BrandCSS = "";
  if (ApiUrl.includes("refactor")) {
    BrandCSS = "refactor";
  } else {
    BrandCSS = null;
  }
  const jsonFile = useSelector((state) => state.style);
  return (
    <>
      {/* begin::Brand */}
      <div
        className={`brand flex-column-auto ${layoutProps.brandClasses} ${BrandCSS}`}
        id="kt_brand"
        style={{ justifyContent: "center", width: "100%" }}
      >
        {/* begin::Logo */}
        <Link
          to="/welcome"
          className="brand-logo"
          style={{ width: "100%", height: "100%" }}
        >
          {/*<img alt="logo" src={layoutProps.headerLogo}/>*/}
          <img
            alt="logo Brand"
            style={{ objectFit: "contain", width: "60%" }}
            src={jsonFile?.sidemenueLogo}
          />
        </Link>
        {/* end::Logo */}

        {layoutProps.asideSelfMinimizeToggle && (
          <>
            {/* begin::Toggle */}

            <button
              className="brand-toggle btn btn-sm px-0"
              id="kt_aside_toggle"
              onClick={handler}
            >
              <span className="svg-icon svg-icon-xl">
                <SVG
                  className={` ${!fav ? "" : " hidden"}`}
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Navigation/Angle-double-right.svg"
                  )}
                />
              </span>
              <img
                className={` ${fav ? "" : " hidden"}`}
                alt="logo Brand"
                src={jsonFile?.sideMenuLogoCollapsed}
              />
            </button>
            {/* end::Toolbar */}
          </>
        )}
      </div>
      {/* end::Brand */}
    </>
  );
}
